import React, { createContext, FC, PropsWithChildren, RefObject } from 'react';
import invariant from 'tiny-invariant';
import { apiConfig } from './apiConfig';

interface PageContextInterface {
  scrollToTop: () => void;
  apiConfig: ReturnType<typeof apiConfig>;
}

const PageContext = createContext<PageContextInterface>({} as PageContextInterface);

interface Props {
  pageRef: RefObject<HTMLDivElement>;
  apiConfig: ReturnType<typeof apiConfig>;
}

export const PageProvider: FC<PropsWithChildren<Props>> = ({ apiConfig, children, pageRef }) => {
  const scrollToTop = (): void => {
    if (pageRef.current) {
      pageRef.current.scrollTop = 0;
    }
  };

  const value = {
    scrollToTop,
    apiConfig,
  };

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
};

export const usePageContext = (): PageContextInterface => {
  const context = React.useContext(PageContext);
  invariant(
    context && Object.prototype.hasOwnProperty.call(context, 'scrollToTop'),
    'usePageContext must be used within a PageProvider'
  );
  return context;
};
